import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejarlo llorar?',
    a: 'No, la pausa es de observación, si el llanto escala, intervienes según nuestra escalera de apoyo.'
  }, {
    q: '¿Funciona si hago colecho?',
    a: 'Sí, el método se adapta perfectamente a camas compartidas o cunas side-car.'
  }, {
    q: '¿Qué pasa si mi bebé tiene hambre?',
    a: 'La guía enseña a distinguir el llanto de hambre real de los despertares por hábito.'
  }, {
    q: '¿Es seguro?',
    a: 'Totalmente, se basa en la biología del sueño infantil y recomendaciones de seguridad.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Verás cambios en la calidad del sueño desde la segunda o tercera noche.'
  }, {
    q: '¿Necesito comprar accesorios caros?',
    a: 'No, solo lo que ya tienes en casa y quizás una cortina oscura o ruido blanco.'
  }];
  return <section className="bg-dark-100 text-text-dark py-20 md:py-28 px-6" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-29">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-30"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-32" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay: index * 0.1
  }} className="border border-accent/20 rounded-xl overflow-hidden bg-dark-200" data-id="element-33">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
        <span className="font-serif text-lg md:text-xl pr-4" data-id="element-35">{question}</span>
        <ChevronDown className={`w-5 h-5 text-accent transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-36" />
      </button>
      <AnimatePresence data-id="element-37">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-38">
            <div className="px-6 pb-5 text-text-dark/70 text-lg" data-id="element-39">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}